import "./UnpublishedChangesNote.scss";

export interface UnpublishedChangesNoteProps {
  onPublish: () => void;
}

export default function UnpublishedChangesNote({ onPublish }: UnpublishedChangesNoteProps) {
  function onClick(ev: React.MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();
    onPublish();
  }

  return (
    <span className="unpublished-changes-note">
      <em>Unpublished Changes!</em>
      <button type="button" className="ucn-publish" onClick={onClick}>Publish</button>
    </span>
  );
}
